<template>
  <v-chip
    v-if="!playerStats.sick || playerStats.sick === false"
    label
    small
    color="grey lighten-3"
  >
    {{ $t('status.sickness.ok') }}
  </v-chip>
  <v-tooltip
    v-else-if="playerStats.sick === true"
    top
  >
    <template v-slot:activator="{ on }">
      <v-chip
        label
        small
        color="error"
        style="cursor: pointer"
        v-on="on"
      >
        {{ $t("status.sickness.feels_sick") }}
      </v-chip>
    </template>
    <div>
      <div
        v-for="symptom in (playerStats.symptoms || [])"
        :key="'symptom' + symptom.id"
      >
        {{ $t(`symptoms.${toCamelCase(symptom.symptom )}`) }}
      </div>
    </div>
  </v-tooltip>
</template>
<script>

import { toCamelCase } from '@/utils/helpers'

export default {
  name: 'SicknessLabel',
  components: { },
  props: {
    playerStats: {
      type: [Object, Array],
      default: () => ({})
    }
  },
  computed: {
  },
  methods: { toCamelCase }
}
</script>
